<template>
  <div>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">
              Type
            </th>
            <th class="text-left">
              Document
            </th>
            <th class="text-left"
              v-if="projectStatus !== 'APPROVED' && (role === 'CLUB_PRESIDENT' || role === 'CLUB_SECRETARY' || role === 'CLUB_TREASURER' || role === 'CLUB_ADMINISTRATOR')">
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in documents" :key="item.uuid">
            <td v-if="item.role">{{ item.role.name }}</td>
            <td>{{ item.comments }}</td>
            <td>
              <img v-if="item.type !== 'pdf'" :src="item.path" width="100" />
              <a v-else :href="item.path" target="_blank"> PDF</a>
            </td>
            <td>
              <v-icon color="red" @click="deleteDocument(item.uuid)">
                mdi-delete-circle
              </v-icon>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
export default {
  name: "documentsList",

  props: ["documents", "projectStatus"],
  components: {},

  data: () => ({
    loading: false,
    role: localStorage.getItem('role') || null
  }),

  methods: {
    submit() {
      this.loading = true;
    },
    deleteDocument(id) {
      this.$emit("deleteDocument", id);
    },
  },
};
</script>
